module.exports = __webpack_public_path__ + "static/media/tile-facepainting.00c2075b.jpg";